import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SumsPage } from '@/features/commercial/sums-page';

const searchSchema = z.object({
  tab: z.enum(['sums', 'adjustments']).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/commercial/sums')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <SumsPage projectId={projectId} tab={search.tab} />;
}
